<template>
  <div class="content" style="background-color:#EFF3F8">
    <div class="container-fluid">
      <!-- <div class="uk-margin marquee">
        <marquee direction="right">Le texte défile vers la droite </marquee>
      </div> -->
      <div class="mb-3">
        <span style="font-size:1.2em">
          <i
            class="fa fa-signal"
            aria-hidden="true"
            style="font-weight:bold; color:#FFAB0E"
          ></i>
          &nbsp; Données en chiffre
        </span>
      </div>

      <div class="row d-flex justify-content-center">
        <div class="col-xl-2 col-md-6">
          <router-link :to="{ path: '/admin/livraison/encours' }">
            <stats-card
              align="center"
              style="border-radius: 16px 16px 16px 16px"
            >
              <div slot="footer">
                <h2 class="card-title" style="font-weight:bold; color:#FFAB0E">
                  {{ countLivraisons.length }}
                </h2>
                <span style="font-size:1.2em; color:black"
                  >Livraisons en cours
                </span>
                <span class="uk-margin-small-right" uk-icon="more"></span>
              </div>
            </stats-card>
          </router-link>
        </div>

        <!-- uk-scrollspy="cls: uk-animation-slide-top; delay: 600; repeat: true"   for animation -->
        <div class="col-xl-2 col-md-6">
          <router-link :to="{ path: '/admin/livraison/completed' }">
            <stats-card
              align="center"
              style="border-radius: 16px 16px 16px 16px"
            >
              <div slot="footer">
                <h2 class="card-title" style="font-weight:bold; color:#34B76E">
                  {{ countLivraisonsAcceptees.length }}
                </h2>
                <span style="font-size:1.2em; color:black"
                  >Livraisons acceptées</span
                >
                <span class="uk-margin-small-right" uk-icon="check"></span>
              </div>
            </stats-card>
          </router-link>
        </div>

        <div class="col-xl-2 col-md-6">
          <router-link :to="{ path: '/admin/livraison/nocompleted' }">
            <stats-card
              align="center"
              style="border-radius: 16px 16px 16px 16px"
            >
              <div slot="footer">
                <h2 class="card-title" style="font-weight:bold; color:#cc2329">
                  {{ countLivraisonsNoAcceptees.length }}
                </h2>
                <span style="font-size:1.2em; color:black"
                  >Livraisons non acceptées</span
                >
                <span class="uk-margin-small-right" uk-icon="close"></span>
              </div>
            </stats-card>
          </router-link>
        </div>

        <!-- <div class="col-xl-2 col-md-6">
          <router-link :to="{path: '/admin/gestion/Livreurs' }">
            <stats-card  align="center" style="border-radius: 16px 16px 16px 16px">
              <div slot="footer">
                <h2 class="card-title" style="font-weight:bold; color:#E117D1">{{countLivreursActifs.length}}</h2>
                <span style="font-size:1.2em; color:black">Livraisons terminées</span>
              </div>
            </stats-card>
          </router-link>
        </div>

        <div class="col-xl-2 col-md-6">
          <router-link :to="{path: '/admin/livraison/retours' }">
            <stats-card  align="center" style="border-radius: 16px 16px 16px 16px">
              <div slot="footer">
                <h2 class="card-title" style="font-weight:bold; color:#DC460F">{{countRetours.length}}</h2>
                <span style="font-size:1.2em; color:black">Livraisons non effectuées </span>
              </div>
            </stats-card>
          </router-link>
        </div> -->
      </div>
      <div class="row d-flex justify-content-center">
        <!-- <div class="col-xl-2 col-md-6">
          <router-link :to="{path: '/admin/livraison/encours' }">
            <stats-card  align="center" style="border-radius: 16px 16px 16px 16px">
              <div slot="footer">
                <h2 class="card-title" style="font-weight:bold; color:#34B76E">{{countLivraisons.length}}</h2>
                <span style="font-size:1.2em; color:black">Livraisons en cours</span>
              </div>
            </stats-card>
          </router-link>
        </div> -->

        <div class="col-xl-2 col-md-6">
          <router-link :to="{ path: '/admin/clients' }">
            <stats-card
              align="center"
              style="border-radius: 16px 16px 16px 16px"
            >
              <div slot="footer">
                <h2 class="card-title" style="font-weight:bold; color:#FFAB0E">
                  {{ countUsers.length }}
                </h2>
                <span style="font-size:1.2em; color:black">Utilisateurs</span>
              </div>
            </stats-card>
          </router-link>
        </div>

        <div class="col-xl-2 col-md-6">
          <router-link :to="{ path: '/admin/boutiques' }">
            <stats-card
              align="center"
              style="border-radius: 16px 16px 16px 16px"
            >
              <div slot="footer">
                <h2 class="card-title" style="font-weight:bold; color:#13D0D3">
                  {{ countBoutiques.length }}
                </h2>
                <span style="font-size:1.2em; color:black">Boutiques</span>
              </div>
            </stats-card>
          </router-link>
        </div>

        <div class="col-xl-2 col-md-6">
          <router-link :to="{ path: '/admin/gestion/Livreurs' }">
            <stats-card
              align="center"
              style="border-radius: 16px 16px 16px 16px"
            >
              <div slot="footer">
                <h2 class="card-title" style="font-weight:bold; color:#E117D1">
                  {{ theLivreurs - 0 }}
                </h2>
                <span style="font-size:1.2em; color:black">Livreurs</span>
              </div>
            </stats-card>
          </router-link>
        </div>
      </div>
      <div>
        <span style="font-size:1.2em">
          <i
            class="fa fa-eye-slash"
            aria-hidden="true"
            style="font-weight:bold; color:#FFAB0E"
          ></i>
          &nbsp; Observations
        </span>
      </div>
      <div class="row">
        <div class="col-md-1"></div>
        <div class="col-md-6" style="background-color:#EFF3F8">
          <card
            class="strpied-tabled-with-hover"
            body-classes="table-full-width table-responsive"
            style="border-radius: 16px 16px 16px 16px"
          >
            <template slot="header">
              <h5 style="font-weight:bold">Livraisons récentes</h5>
            </template>
            <table class="table">
              <thead>
                <tr>
                  <th
                    scope="col"
                    style="color:#34B76E; font-weight:bold; font-size:0.9em"
                  >
                    Nature
                  </th>
                  <th
                    scope="col"
                    style="color:#34B76E; font-weight:bold; font-size:0.9em"
                  >
                    statut
                  </th>
                  <th
                    scope="col"
                    style="color:#34B76E; font-weight:bold; font-size:0.9em"
                  >
                    Montant
                  </th>
                  <th
                    scope="col"
                    style="color:#34B76E; font-weight:bold; font-size:0.9em"
                  >
                    Type
                  </th>
                  <th
                    scope="col"
                    style="color:#34B76E; font-weight:bold; font-size:0.9em"
                  >
                    Actions
                  </th>
                </tr>
              </thead>

              <tbody>
                <tr v-for="coli in Colis.slice(0, 5)" :key="coli.id">
                  <td>{{ coli.nature }}</td>
                  <td>{{ coli.statut }}</td>
                  <td>{{ coli.montant }} FCFA</td>
                  <td>{{ coli.colis_type }}</td>
                  <td>
                    <router-link
                      :to="{ path: '/Voir_livraisons/' + coli.id }"
                      v-bind:tooltip="coli.id"
                      class="btn btn-default"
                    >
                      <i
                        class="fa fa-eye"
                        aria-hidden="true"
                        style="color:#34B76E; font-weight:bold"
                      ></i>
                    </router-link>
                  </td>
                </tr>
              </tbody>
            </table>
          </card>
        </div>

        <!-- <div class="col-md-5" style="background-color:#EFF3F8">
            <card class="strpied-tabled-with-hover"
                  body-classes="table-full-width table-responsive" style="border-radius: 16px 16px 16px 16px">
              <template slot="header">
                <h5 style="font-weight:bold">Recettes par livreur utilisant l'application</h5>  
              </template>
              <table class="table">
                <thead>
                  <tr> 
                    <th scope="col" style="color:#34B76E; font-weight:bold; font-size:0.9em">Noms</th>
                    <th scope="col" style="color:#34B76E; font-weight:bold; font-size:0.9em">Recettes</th>
                  </tr>
                </thead>

                <tbody>
                  
                  <tr v-for="tot in countTotalLiv " :key="tot.id">
                    <td>{{ tot.livname }} </td>
                    <td>{{ tot.Mt }} FCFA</td>
                  </tr>

                </tbody>
              </table>
            </card>
        </div> -->
      </div>
    </div>
  </div>
</template>
<script>
import { db, dbstore } from "../main";

import ChartCard from "src/components/Cards/ChartCard.vue";
import StatsCard from "src/components/Cards/StatsCard.vue";

import LTable from "src/components/Rapports/TableLivraisons.vue";
import Card from "src/components/Cards/Card.vue";

const tableColumns = ["Id", "Option1", "Option2", "Option3", "Option4"];
const tableData = [
  {
    id: 1,
    Option1: "........",
    Option2: "........",
    Option3: "........",
    Option4: "........",
  },
];

export default {
  components: {
    LTable,
    ChartCard,
    StatsCard,
    Card,
  },

  data() {
    return {
      countLivraisonsAcceptees: [],
      countLivraisonsNoAcceptees: [],
      countLivraisonsAnnulees: [],
      countTotalLiv: [],
      countLivraisons: [],
      countUsers: [],
      countLivreursActifs: [],
      theLivreurs: null,
      countRetours: [],
      countBoutiques: [],
      Colis: [],
      boutiques: [],
      table1: {
        columns: [...tableColumns],
        data: [...tableData],
      },
      table2: {
        columns: [...tableColumns],
        data: [...tableData],
      },

      editTooltip: "Edit Task",
      deleteTooltip: "Remove",
      pieChart: {
        data: {
          labels: ["40%", "20%", "40%"],
          series: [40, 20, 40],
        },
      },
      lineChart: {
        data: {
          labels: [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "Mai",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec",
          ],
          series: [[23, 113, 67, 108, 190, 239, 307, 308, 113, 67, 108, 190]],
        },
        options: {
          low: 0,
          high: 800,
          showArea: false,
          height: "245px",
          axisX: {
            showGrid: false,
          },
          lineSmooth: true,
          showLine: true,
          showPoint: true,
          fullWidth: true,
          chartPadding: {
            right: 50,
          },
        },
        responsiveOptions: [
          [
            "screen and (max-width: 640px)",
            {
              axisX: {
                labelInterpolationFnc(value) {
                  return value[0];
                },
              },
            },
          ],
        ],
      },

      barChart: {
        data: {
          labels: [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "Mai",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec",
          ],
          series: [
            [542, 443, 320, 780, 553, 453, 326, 434, 568, 610, 756, 895],
          ],
        },
        options: {
          seriesBarDistance: 10,
          axisX: {
            showGrid: false,
          },
          height: "245px",
        },
        responsiveOptions: [
          [
            "screen and (max-width: 640px)",
            {
              seriesBarDistance: 5,
              axisX: {
                labelInterpolationFnc(value) {
                  return value[0];
                },
              },
            },
          ],
        ],
      },
      tableData: {
        data: [
          {
            title:
              'Sign contract for "What are conference organizers afraid of?"',
            checked: false,
          },
          {
            title:
              "Lines From Great Russian Literature? Or E-mails From My Boss?",
            checked: true,
          },
          {
            title:
              "Flooded: One year later, assessing what was lost and what was found when a ravaging rain swept through metro Detroit",
            checked: true,
          },
          {
            title: "Create 4 Invisible User Experiences you Never Knew About",
            checked: false,
          },
          { title: 'Read "Following makes Medium better"', checked: false },
          { title: "Unfollow 5 enemies from twitter", checked: false },
        ],
      },
      api_key: "7f2bd7abf3c5d22d4efed682ce644465",
      url_base: "https://api.openweathermap.org/data/2.5/",
      query: "",
      weather: {},
    };
  },

  methods: {
  },

  created() {
    //Recuperations des livraisons
    db.ref("Colis Requetes").once("value", (dataSnapshot) => {
      const itemsArray = [];
      dataSnapshot.forEach((childSnapshot) => {
        itemsArray.push({});
        this.countLivraisons = itemsArray;
      });
    });

    //Recuperation des utilisateurs
    db.ref("users").once("value", (dataSnapshot) => {
      const itemsArray = [];
      dataSnapshot.forEach((childSnapshot) => {
        const childData = childSnapshot.val();
        itemsArray.push({
          id: childData.id,
          name: childData.name,
          role: childData.role,
        });
        this.countUsers = itemsArray;
      });
    });

    //Recupération de livreur Actifs
    db.ref("users")
    .orderByChild("role")
    .equalTo("1")
    .once("value", (dataSnapshot) => {
        const itemsArray = [];
        dataSnapshot.forEach((childSnapshot) => {
          itemsArray.push({});
          const countLivreurs = this.countLivreursActifs = itemsArray;
          this.theLivreurs = countLivreurs.length -2;
        });
      });

    //Recuperation des boutiques
    dbstore.collection("boutiques").get().then((querySnapshot) => {
        const itemsArray = [];
        querySnapshot.forEach((childSnapshot) => {
          itemsArray.push({});
          this.countBoutiques = itemsArray;
        });
      });

    //Recuperation des retours
    dbstore.collection("livraison_retour").get().then((querySnapshot) => {
        const itemsArray = [];
        querySnapshot.forEach((childSnapshot) => {
          itemsArray.push({});
          this.countRetours = itemsArray;
        });
      });

    db.ref("Colis Requetes").once("value", (dataSnapshot) => {
      const itemsArray = [];
      dataSnapshot.forEach((childSnapshot) => {
        const childData = childSnapshot.val();
        this.Colis = childData;
        itemsArray.push({
          id: childData.id_colis,
          client_name: childData.client_name,
          client_phone: childData.client_phone,
          colis_type: childData.colis_type,
          depart_address: childData.depart_address,
          dest_address: childData.dest_address,
          dest_contact: childData.dest_contact,
          montant: childData.montant,
          nature: childData.nature,
          statut: childData.statut,
          livreur_id: childData.livreur_id,
          payment_method: childData.payment_method,
        });
      });
      this.Colis = itemsArray.reverse();
    });

    //Recuperations des livraisons accpetées
    db.ref("Colis Requetes").orderByChild("statut").equalTo("accepter").once("value", (dataSnapshot) => {
        const itemsArray = [];
        dataSnapshot.forEach((childSnapshot) => {
          itemsArray.push({});
          this.countLivraisonsAcceptees = itemsArray;
        });
      });

    // new Date(Date.now())
    // countLivraisonsAnnulees
    // const dateTime = new Date(Date)
    db.ref("ReponsesAnnulations").once("value", (dataSnapshot) => {
      const itemsArray = [];
      dataSnapshot.forEach((childSnapshot) => {
        itemsArray.push({});
        this.countLivraisonsAnnulees = itemsArray;
      });
    });


    //Recuperations des livraisons accpetées
    db.ref("Colis Requetes").orderByChild("statut").equalTo("attente").once("value", (dataSnapshot) => {
        const itemsArray = [];
        dataSnapshot.forEach((childSnapshot) => {
          itemsArray.push({});
          this.countLivraisonsNoAcceptees = itemsArray;
        });
      });

    let sumCol = this.Colis;
    let sumUsr = this.countUsers;
    const itemsArray = [];
    let MontantTotal = 0;
    let Name = "";

    for (let index = 0; index < sumUsr.length; index++) {
      if (sumUsr[index].role == "1") {
        for (let mon = 0; mon < sumCol.length; mon++) {
          if (sumUsr[index].id == sumCol[mon].livreur_id) {
            MontantTotal = MontantTotal + sumCol[mon].montant;
            Name = sumUsr[index].name;
          } else {
            MontantTotal = MontantTotal + 0;
            Name = sumUsr[index].name;
          }
        }

        itemsArray.push({
          id: sumUsr[index].id,
          livname: Name,
          Mt: MontantTotal,
        });
      }
    }
    this.countTotalLiv = itemsArray.reverse();
  },
};
</script>
<style>
@import url("https://fonts.googleapis.com/css2?family=Josefin+Sans:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;1,100;1,200;1,300;1,400;1,500;1,600;1,700&display=swap");

* {
  font-family: "Josefin Sans", sans-serif;
}

/* .marquee {
  font-size: 1.5rem;
  font-weight: bold;
  color: #fff;
  background: linear-gradient(to right, #13D0D3, #10A4A6);
  padding: 0.2rem;
  border-radius: 0.2rem;
  animation: marquee 15s linear infinite;
} */

.uk-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.uk-container input {
  margin-top: 2rem;
  border: 1px solid rgb(5, 170, 101);
  background-color: rgba(255, 255, 255);
}

.uk-flex-between {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.uk-flex-between span {
  font-size: 2.5rem;
  color: #34b76e;
}
/* .uk-container  */
</style>
